import EventAddMapper from './event-add-mapper';
import SportEventModel from '../sport-event/sport-event-model';

const EventAddModel = {
    mapper: EventAddMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    event: {
        fieldName: 'v',
        model: SportEventModel,
        type: Object,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },
};

export default EventAddModel;
